module.exports = __webpack_public_path__ + "img/description1.fc15071d.jpg";